export default {
  state: () => ({
    groups: {},
    parents: [],
    activeGroup: ''
  })
}



// WEBPACK FOOTER //
// ./src/app/store/groups/config.js